import Link from "@client/controls/Link/container";
import { type MenuItem } from "@client/types/Menu";
import { type WithChildren } from "@client/types/WithChildren";
import * as React from "react";
import { type To } from "react-router-dom";

export type MapProps = WithChildren & {
  isClickable: boolean;
  isExpanded: boolean;
  item: MenuItem;
  style?: React.CSSProperties;
};

export type ActionProps = {
  onToggleClick?: (id: string) => React.MouseEventHandler;
};

export default ({ item, ...props }: ActionProps & MapProps) => {
  const onClick = React.useCallback(
    (e: React.MouseEvent) => {
      e.nativeEvent.preventDefault();
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();

      if (props.isClickable && item.children.length) {
        props.onToggleClick && props.onToggleClick(item.id)(e);
      } else if (item.link && item.isEnabled) {
        if (item.openInNewWindow || e.ctrlKey || e.metaKey) {
          window.open(item.link);
        }
      }
    },
    [props.isClickable, item, props.onToggleClick]
  );

  const to = React.useMemo(
    (): To | undefined => (item.link && item.isEnabled ? { pathname: item.link } : undefined),
    [item.link, item.isEnabled]
  );

  return <Link children={props.children} style={props.style} onClick={to ? undefined : onClick} to={to} />;
};
